const PromoCartSync = {
  refCount: 0,
  idleResolvers: [],
  promoQueue: Promise.resolve(),
  bound: false,

  acquire() {
    this.refCount += 1;
    if (this.refCount === 1) {
      this.setLocked(true);
    }
  },

  release() {
    this.refCount = Math.max(0, this.refCount - 1);
    if (this.refCount === 0) {
      this.setLocked(false);
      this.idleResolvers.splice(0).forEach((resolve) => resolve());

      if (typeof schedulePostPromoStrikethroughRefresh === 'function') {
        schedulePostPromoStrikethroughRefresh();
      }
    }
  },

  whenIdle() {
    if (this.refCount === 0) {
      return Promise.resolve();
    }

    return new Promise((resolve) => {
      this.idleResolvers.push(resolve);
    });
  },

  whenSettled() {
    return this.promoQueue;
  },

  enqueuePromo(work) {
    this.acquire();

    const task = this.promoQueue
      .then(() => work())
      .finally(() => {
        this.release();
      });

    this.promoQueue = task.catch(() => {});
    return task;
  },

  isLocked() {
    return this.refCount > 0;
  },

  refreshLockUI() {
    this.setLocked(this.refCount > 0);
  },

  setLocked(locked) {
    document.body.classList.toggle('cart--promo-syncing', locked);

    document.querySelectorAll('cart-drawer, cart-items, cart-drawer-items').forEach((element) => {
      element.classList.toggle('cart--promo-syncing', locked);
    });

    document.getElementById('main-cart-items')?.classList.toggle('cart--promo-syncing', locked);
    document.getElementById('main-cart-footer')?.classList.toggle('cart--promo-syncing', locked);

    document.querySelectorAll('.cart__checkout-button, .cart__clear-button').forEach((button) => {
      button.classList.toggle('disabled', locked);
      button.toggleAttribute('disabled', locked);

      if (button.tagName === 'A') {
        button.setAttribute('aria-disabled', locked ? 'true' : 'false');
      }
    });

    document.querySelectorAll('.additional-checkout-buttons, .cart__dynamic-checkout-buttons').forEach((element) => {
      element.classList.toggle('cart__checkout-buttons--disabled', locked);
      element.setAttribute('aria-hidden', locked ? 'true' : 'false');
    });

    const mainCartItems =
      document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems?.classList.toggle('cart__items--disabled', locked);
  },

  bindCheckoutGuards() {
    if (this.bound) return;
    this.bound = true;

    document.addEventListener(
      'click',
      (event) => {
        if (!this.isLocked()) return;

        const checkoutButton = event.target.closest('.cart__checkout-button, .cart__clear-button');
        const dynamicCheckout = event.target.closest('.additional-checkout-buttons, .cart__dynamic-checkout-buttons');

        if (checkoutButton || dynamicCheckout) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );

    document.addEventListener(
      'submit',
      (event) => {
        if (!this.isLocked()) return;

        const cartForm = event.target.closest('#CartDrawer-Form, #cart, form[action="/cart"]');
        if (cartForm) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );
  },
};

PromoCartSync.bindCheckoutGuards();
window.PromoCartSync = PromoCartSync;
